import { observer } from 'mobx-react';
import { SearchBar } from '../shared/search-bar';
import { Page } from '../shared/page';
import { OnePaneLayout } from '../shared/layouts';
import { PageActions } from '../shared/page-actions';
import { FeaturedReleasesTable } from './featured-releases-table';
import { Link } from 'react-router-dom';
import { FeaturedReleaseManager } from '@masala-lib/catalog/db/featured-release-manager';
import { Auth } from '@masala-lib/editorial/db/auth';

export const FeaturedReleasesListScreen = observer(() => {
  const auth = Auth.getInstance();
  const manager = FeaturedReleaseManager.getInstance();
  const list = manager.list;

  return (
    <Page
      title="Manage Collections"
      controls={
        <PageActions>
          {auth.isAdmin ? (
            <Link to={'/featured-releases/new'} className="primary-action">
              Create new Collection
            </Link>
          ) : null}
          <SearchBar manager={manager} />
        </PageActions>
      }
    >
      <OnePaneLayout>
        <FeaturedReleasesTable list={list} />
      </OnePaneLayout>
    </Page>
  );
});
